<template>
	<div class="row">
		<div
			v-for="(colData, colDataIndex) in $parent.data.results"
			:key="colDataIndex"
			class="col-12 col-sm-6 col-xl-4 col-xxl-3"
		>
			<slot
				name="_mobile"
				v-bind="colData"
				class="card"
				:class="$style.card"
			>
				<div
					class="card"
					:class="$style.card"
				>
					<div class="card-body py-0 px-3">
						<div
							v-for="(col, colIndex) in $parent.cols"
							:key="colIndex"
							class="row"
							:class="[$style.cardRow, $style[`card${col.slot}`]]"
						>
							<div
								v-if="col.slot !== '_actions'"
								class="col-6"
								:class="$style.cardCol"
							>
								<h5 :class="$style.cardTitle">
									{{ col.title || col.index || '???' }}
								</h5>
							</div>

							<div
								:class="[
									$style.cardCol,
									col.slot === '_actions' ? 'col-12': 'col-6'
								]"
								:style="{'text-align': (col.align || 'left')}"
							>
								<slot
									v-if="col.slot==='_actions'"
									name="_actions"
									v-bind="colData"
								>
									<slot-action
										:item="colData"
										:app="$parent.app"
										:mobile="true"
										@edit="$parent.$emit('edit', $event)"
									/>
								</slot>

								<slot
									v-else-if="col.slot==='_email'"
									name="_email"
									v-bind="colData"
								>
									<slot-email :item="colData[col.index]" />
								</slot>

								<slot
									v-else-if="col.slot==='_date'"
									name="_date"
									v-bind="colData"
								>
									<slot-date :item="colData[col.index]" />
								</slot>

								<slot
									v-else-if="col.slot==='_datetime'"
									name="_datetime"
									v-bind="colData"
								>
									<slot-datetime :item="colData[col.index]" />
								</slot>

								<slot
									v-else-if="col.slot==='_time'"
									name="_time"
									v-bind="colData"
								>
									<slot-time :item="colData[col.index]" />
								</slot>

								<slot
									v-else-if="col.slot==='_select'"
									name="_select"
									v-bind="colData"
								>
									<slot-select
										:item="colData[col.index]"
										:index="col.index"
										:app="$parent.app"
									/>
								</slot>

								<slot
									v-else-if="col.slot==='_user'"
									name="_user"
									v-bind="colData"
								>
									<slot-user :item="colData[col.index]" />
								</slot>

								<slot
									v-else-if="col.slot!==undefined"
									:name="col.slot"
									v-bind="colData"
								>
									{{ colData[col.index] }}
								</slot>

								<div v-else>
									{{ colData[col.index] }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</slot>
		</div>
	</div>
</template>

<script>
import slotAction from '../slots/actions';
import slotEmail from '../slots/email';
import slotDate from '../slots/date';
import slotUser from '../slots/user';
import slotSelect from '../slots/select';

export default {
	components: {
		slotAction,
		slotEmail,
		slotDate,
		slotUser,
		slotSelect
	}
};
</script>

<style lang="scss" module>
	.card {
		.cardRow:nth-child(even){
			position: relative;
		}

		.cardRow:nth-child(even)::before{
			width: 100%;
			height: 100%;
			display: block;
			content: ' ';
			z-index: 0;
			position: absolute;
			left: 0;
			top: 0;
			background-color: $gray-2;
		}

		.cardRow{
			display: flex;
			align-items: center;
			padding: 10px;

			.cardCol{
				position: relative;
				z-index: 1;
			}
		}

		.cardRow.card_actions, .cardRow.card_actionsMobile{
			padding: 10px 0;
		}

		.cardTitle{
			font-size: 1.2em;
			margin-bottom: 0;
		}
	}

	[data-kit-theme='dark'] {
		.card {
			.cardRow:nth-child(even)::before{
				background-color: $dark-gray-4;
			}
		}
	}
</style>
